import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { LoginService } from './login.service';
import { Router } from '@angular/router';
import { UserService } from '../../shared/user/user.service';
import { select, Store } from '@ngrx/store';
import * as fromLogin from './state/login.reducer';
import * as fromLoginActions from './state/login.actions';
import * as fromLoginSelectors from '../../access/login/state/login.selectors';
import { AppState } from '../../shared/state/app.reducer';
import { Observable } from 'rxjs';

@Component({
  selector: 'lwa-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [],
})
export class LoginComponent implements OnInit {

  form: UntypedFormGroup;
  token: string;
  loading$: Observable<boolean>;

  constructor(private authService: LoginService,
              private userService: UserService,
              private router: Router,
              private store: Store<AppState>) {
  }

  ngOnInit(): void {
    this.form = new UntypedFormGroup({
        email: new UntypedFormControl(undefined),
        password: new UntypedFormControl(undefined),
      },
    );

    this.loading$ = this.store.select(fromLoginSelectors.selectLoadingLogin);
  }

  autenticar(): void {
    this.store.dispatch(fromLoginActions.login({ email: this.form.value.email, password: this.form.value.password }));
  }
}
